export const formatAdminOrderDate = value => value ? new Intl.DateTimeFormat('es-MX', {
    timeZone: 'America/Mexico_City', day: '2-digit', month: 'long', year: 'numeric',
    hour: 'numeric', minute: '2-digit'
}).format(new Date(value)) : 'No disponible';

export const formatAdminOrderTableDate = value => {
    if (!value) return 'No disponible';
    const parts = new Intl.DateTimeFormat('es-MX', {
        timeZone: 'America/Mexico_City', day: '2-digit', month: 'long',
        hour: '2-digit', minute: '2-digit', hour12: true
    }).formatToParts(new Date(value));
    const get = type => parts.find(part => part.type === type)?.value || '';
    const period = get('dayPeriod').replace(/[.\s]/g, '').toUpperCase();
    return `${get('hour')}:${get('minute')} ${period} - ${get('day')}/${get('month')}`;
};

export const formatAdminOrderTotal = value => `$${new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
}).format(Number(value) || 0)}`;

export const formatAdminDateKey = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return 'Fecha no disponible';
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 ||
        date.getUTCDate() !== day) return 'Fecha no disponible';
    return new Intl.DateTimeFormat('es-MX', {
        timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric'
    }).format(date);
};

export const formatAdminDateRange = (dateFrom, dateTo) =>
    `${formatAdminDateKey(dateFrom)} al ${formatAdminDateKey(dateTo)}`;

export const elapsedLabel = (value, now = Date.now()) => {
    if (!value) return 'Fecha no disponible';
    const hours = Math.max(0, Math.floor((now - new Date(value).getTime()) / 3600000));
    if (hours < 24) return `Hace ${hours} h`;
    const days = Math.floor(hours / 24);
    return `Hace ${days} día${days === 1 ? '' : 's'}`;
};

const dateKey = date => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0')].join('-');

export const orderDatePreset = (preset, todayKey) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(todayKey || ''))
        return { dateFrom: '', dateTo: '' };
    const today = new Date(`${todayKey}T12:00:00`);
    if (preset === 'previous') {
        const start = new Date(today.getFullYear(), today.getMonth() - 1, 1, 12);
        const end = new Date(today.getFullYear(), today.getMonth(), 0, 12);
        return { dateFrom: dateKey(start), dateTo: dateKey(end) };
    }
    if (preset === '90days') {
        const start = new Date(today);
        start.setDate(start.getDate() - 89);
        return { dateFrom: dateKey(start), dateTo: todayKey };
    }
    return { dateFrom: `${todayKey.slice(0, 7)}-01`, dateTo: todayKey };
};

export const transitionNotice = result => {
    if (result.transition !== 'changed')
        return 'El pedido ya tenía ese estado; no se envió otro correo.';
    const failed = Object.values(result.emails || {}).some(value => value === false);
    return failed ? 'El pedido fue actualizado, pero uno o más correos no pudieron enviarse.' : '';
};
